import React from 'react'
import { observer } from 'mobx-react'
import ContentLoading from 'components/ContentLoading'
import OCRScopingJobSidePanelViewModel from './OCRScopingJobSidePanelViewModel'
import { Sandwich, SandwichBun, SandwichContent } from 'components/Sandwich'
import OCRScopingJobsListHeader from './OCRScopingJobsListHeader'
import ErrorBlock from 'components/ErrorBlock'
import ScrollView from 'components/ScrollView'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import OCRScopeJobItem from './OCRScopeJobItem'
import CreateOCRScopeJobsViewModel from '../../views/CreateOCRScopeJobsDialog/CreateOCRScopeJobsViewModel'
import styles from './OCRScopingJobSidePanel.sass'
import OCRScopingJobMainPanelViewModel from '../MainPanel/OCRScopingJobMainPanelViewModel'
import OCRBulkActionButton from './OCRBulkActionButton'
import OCRConfirmBulkSubmitModal from '../Modals/OCRConfirmBulkSubmitModal'
import OCRConfirmBulkReviewModal from '../Modals/OCRConfirmBulkReviewModal'
import OCRConfirmBulkRerunModal from '../Modals/OCRConfirmBulkRerunModal'
import OCRBulkProgressModal from '../Modals/OCRBulkProgressModal'

interface OCRScopingJobSidePanelViewModelProps {
  vm: OCRScopingJobSidePanelViewModel
  createOCRScopeJobsVM: CreateOCRScopeJobsViewModel
  ocrScopingJobMainPanelVM: OCRScopingJobMainPanelViewModel
}

export default observer(function OCRScopingJobSidePanel({
  vm,
  createOCRScopeJobsVM,
  ocrScopingJobMainPanelVM,
}: OCRScopingJobSidePanelViewModelProps) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)

  return (
    <Sandwich stretch className={styles.root}>
      {vm.activate.match({
        pending: () => <ContentLoading />,
        rejected: (err: unknown) => <ErrorBlock tackOn="top" error={err} />,
        resolved: () => (
          <>
            <SandwichBun>
              <OCRScopingJobsListHeader vm={vm} />
            </SandwichBun>
            <SandwichContent>
              {vm.selectedStatusFilter && (
                <ScrollView ref={scrollRef}>
                  {vm.ocrScopeWorkJobs.map((scopeWorkJob) => (
                    <OCRScopeJobItem
                      vm={vm.ocrScopingJobBulkActionViewModel}
                      ocrScopingJobMainPanelVM={ocrScopingJobMainPanelVM}
                      item={scopeWorkJob}
                      selectedStatusFilterId={vm.selectedStatusFilter!.id}
                      key={scopeWorkJob.id}
                    />
                  ))}
                  {!vm.scrollProvider.isDone && (
                    <InfiniteScrollLoader scrollProvider={vm.scrollProvider} />
                  )}
                </ScrollView>
              )}
            </SandwichContent>
            <SandwichBun>
              <div className={styles.footer}>
                <OCRBulkActionButton
                  vm={vm.ocrScopingJobBulkActionViewModel}
                  createOCRScopeJobsViewModel={createOCRScopeJobsVM}
                />
                <OCRConfirmBulkSubmitModal
                  vm={
                    vm.ocrScopingJobBulkActionViewModel.confirmBulkSubmitModalVM
                  }
                />
                <OCRConfirmBulkReviewModal
                  vm={
                    vm.ocrScopingJobBulkActionViewModel.confirmBulkReviewModalVM
                  }
                />
                <OCRConfirmBulkRerunModal
                  vm={
                    vm.ocrScopingJobBulkActionViewModel.confirmBulkRerunModalVM
                  }
                />
                <OCRBulkProgressModal
                  vm={vm.ocrScopingJobBulkActionViewModel.bulkProgressModalVM}
                />
              </div>
            </SandwichBun>
          </>
        ),
      })}
    </Sandwich>
  )
})
